"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Explore = _interopRequireDefault(require("@rsuite/icon-font/lib/application/Explore"));

// Generated by script, don't edit it please.
var Explore = (0, _createSvgIcon["default"])({
  as: _Explore["default"],
  ariaLabel: 'explore',
  category: 'application',
  displayName: 'Explore'
});
var _default = Explore;
exports["default"] = _default;
module.exports = exports.default;